<template>
  <component
    :is="sectionComponent"
    v-if="sectionComponent"
    :config="config"
    @show-add-service="$emit('show-add-service')"
  />
  <v-alert v-else type="warning" variant="tonal" class="mb-4">
    {{ t.dashboard?.component_not_available || 'Component is not available' }} — "{{ componentName }}"
  </v-alert>
</template>

<script>
import { t as tRef } from '@/composables/useLanguages'
import SimSearchSection from './SimSearchSection.vue'
import SimAdvancedSearchSection from './SimAdvancedSearchSection.vue'
import ClientServicesSearchSection from './ClientServicesSearchSection.vue'
import ClientSearchSection from './ClientSearchSection.vue'
import AvailableServicesSection from './AvailableServicesSection.vue'
import ServicesStatsSection from './ServicesStatsSection.vue'
import SimsStatsSection from './SimsStatsSection.vue'
import QuickActionsSection from './QuickActionsSection.vue'
import NavigationCardsSection from './NavigationCardsSection.vue'
import AccountManagementSection from './AccountManagementSection.vue'
import TrafficStatsSection from './TrafficStatsSection.vue'
import OrdersStatsSection from './OrdersStatsSection.vue'

const componentMap = {
  'SimSearchSection': SimSearchSection,
  'SimAdvancedSearchSection': SimAdvancedSearchSection,
  'ClientServicesSearchSection': ClientServicesSearchSection,
  'ClientSearchSection': ClientSearchSection,
  'AvailableServicesSection': AvailableServicesSection,
  'ServicesStatsSection': ServicesStatsSection,
  'SimsStatsSection': SimsStatsSection,
  'QuickActionsSection': QuickActionsSection,
  'NavigationCardsSection': NavigationCardsSection,
  'AccountManagementSection': AccountManagementSection,
  'TrafficStatsSection': TrafficStatsSection,
  'OrdersStatsSection': OrdersStatsSection
}

export default {
  name: 'DashboardSectionRenderer',
  props: {
    componentName: { type: String, required: true },
    config: { type: Object, default: () => ({}) }
  },
  emits: ['show-add-service'],
  computed: {
    t() { return tRef.value },
    sectionComponent() {
      return componentMap[this.componentName] || null
    }
  }
}
</script>
